import { apiGuestClient } from './apiGuestClient';

export const API_END_POINT = "dang-ky-an";

export const dangKyAnApi = {
    selectByHocSinh: (ts_hocsinh_id: number) => apiGuestClient.get(`dang-ky-an/${ts_hocsinh_id}`),
    selectCaAnByTruong: (dm_truong_id: number) => apiGuestClient.get(`ca-an-truong/${dm_truong_id}`),
};
